var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-list",
    [
      _c(
        "q-collapsible",
        {
          staticClass: "filter",
          attrs: {
            icon: "fas fa-filter",
            label: _vm.$t("filter"),
            opened: !_vm.$q.platform.is.mobile ? true : false
          }
        },
        [
          _c(
            "q-list",
            { attrs: { "no-border": "" } },
            [
              _c(
                "q-item",
                [
                  _c(
                    "q-item-main",
                    [
                      _c("q-search", {
                        attrs: {
                          placeholder: _vm.$t("search"),
                          icon: "fas fa-search",
                          debounce: 600
                        },
                        on: { input: _vm.changeFilter },
                        model: {
                          value: _vm.search,
                          callback: function($$v) {
                            _vm.search = $$v
                          },
                          expression: "search"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "q-item",
                [
                  _c(
                    "q-item-main",
                    [
                      _c("p", { staticClass: "caption" }, [
                        _vm._v(_vm._s(_vm.$t("progress")))
                      ]),
                      _c("q-btn-toggle", {
                        staticClass: "full-width q-mb-sm progress",
                        attrs: {
                          "toggle-color": "primary",
                          options: [
                            {
                              label: _vm.$t("all"),
                              value: "all",
                              icon: "fas fa-list"
                            }
                          ]
                        },
                        on: { input: _vm.changeFilter },
                        model: {
                          value: _vm.progress,
                          callback: function($$v) {
                            _vm.progress = $$v
                          },
                          expression: "progress"
                        }
                      }),
                      _c("q-btn-toggle", {
                        staticClass: "full-width q-mb-sm progress",
                        attrs: {
                          "toggle-color": "primary",
                          options: [
                            {
                              label: _vm.$t("in_progress"),
                              value: "in-progress",
                              icon: "fas fa-shoe-prints"
                            }
                          ]
                        },
                        on: { input: _vm.changeFilter },
                        model: {
                          value: _vm.progress,
                          callback: function($$v) {
                            _vm.progress = $$v
                          },
                          expression: "progress"
                        }
                      }),
                      _c("q-btn-toggle", {
                        staticClass: "full-width q-mb-sm progress",
                        attrs: {
                          "toggle-color": "primary",
                          options: [
                            {
                              label: _vm.$t("to_do"),
                              value: "to-do",
                              icon: "far fa-edit"
                            }
                          ]
                        },
                        on: { input: _vm.changeFilter },
                        model: {
                          value: _vm.progress,
                          callback: function($$v) {
                            _vm.progress = $$v
                          },
                          expression: "progress"
                        }
                      }),
                      _c("q-btn-toggle", {
                        staticClass: "full-width q-mb-sm progress",
                        attrs: {
                          "toggle-color": "primary",
                          options: [
                            {
                              label: _vm.$t("finished"),
                              value: "finished",
                              icon: "far fa-check-circle"
                            }
                          ]
                        },
                        on: { input: _vm.changeFilter },
                        model: {
                          value: _vm.progress,
                          callback: function($$v) {
                            _vm.progress = $$v
                          },
                          expression: "progress"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "q-item",
                [
                  _c(
                    "q-item-main",
                    [
                      _c("p", { staticClass: "caption" }, [
                        _vm._v(_vm._s(_vm.$t("favorites")))
                      ]),
                      _c("q-btn-toggle", {
                        staticClass: "full-width q-mb-sm progress",
                        attrs: {
                          "toggle-color": "primary",
                          options: [
                            {
                              label: _vm.$t("all"),
                              value: "all",
                              icon: "fas fa-list"
                            }
                          ]
                        },
                        on: { input: _vm.changeFilter },
                        model: {
                          value: _vm.favorite,
                          callback: function($$v) {
                            _vm.favorite = $$v
                          },
                          expression: "favorite"
                        }
                      }),
                      _c("q-btn-toggle", {
                        staticClass: "full-width q-mb-sm progress",
                        attrs: {
                          "toggle-color": "primary",
                          options: [
                            {
                              label: _vm.$t("favorites"),
                              value: "favorites",
                              icon: "far fa-heart"
                            }
                          ]
                        },
                        on: { input: _vm.changeFilter },
                        model: {
                          value: _vm.favorite,
                          callback: function($$v) {
                            _vm.favorite = $$v
                          },
                          expression: "favorite"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "q-item",
                [
                  _c("q-item-main", [
                    _c("p", { staticClass: "text-center" }, [
                      _c(
                        "a",
                        {
                          staticClass: "text-faded",
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.clearFilters()
                            }
                          }
                        },
                        [
                          _c("q-icon", { attrs: { name: "far fa-trash-alt" } }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("clear_filters")) +
                              "\n                        "
                          )
                        ],
                        1
                      )
                    ])
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }